import {
  FINTRAC_STR_ACCOUNT_TYPE_CODE_OPTIONS,
  FINTRAC_STR_CURRENCY_CODES_OPTIONS,
  FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE_OPTIONS,
  FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS,
  FINTRAC_STR_ACCOUNT_TYPE_CODE,
  FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE,
  FINTRAC_STR_DISPOSITION_CODE,
  FINTRAC_STR_DATE_FORMAT,
  FINTRAC_STR_DEFINITION_TYPE_CODE_MAP,
} from 'app/modules/fintracStr/formConstants';
import {
  getDependentPaths,
  getUniqueDefinitionOptions,
} from 'app/modules/fintracStr/formUtils';
import {
  FintracFormFields,
  FintracFormValue,
} from 'app/modules/fintracStr/models';
import { isFieldBlank } from 'app/modules/fintracStr/renderConditions';
import {
  U21FormFieldTypes,
  U21SelectOptionProps,
} from 'app/shared/u21-ui/components';
import { formatDate } from 'app/shared/utils/date';
import { parseFintracDate } from 'app/modules/fintracStr/utils';
import { isUndefined } from 'lodash';

const isPhysicalFundAssetDisposition = (value: FintracFormValue) =>
  value === FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_JEWELERY.value ||
  value === FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_PRECIOUS_METALS.value ||
  value === FINTRAC_STR_DISPOSITION_CODE.HOLDING_FUNDS.value ||
  value === FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_PRECIOUS_STONES.value;

export const FINTRAC_STR_COMPLETING_ACTION_ACCOUNT_INFORMATION_FIELDS: FintracFormFields =
  [
    [
      {
        type: U21FormFieldTypes.TEXT,
        name: 'financialInstitutionNumber',
        label: 'Financial institution number',
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'branchNumber',
        label: 'Branch number',
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
      },
    ],
    [
      {
        type: U21FormFieldTypes.TEXT,
        name: 'number',
        label: 'Account number',
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.SELECT,
        name: 'currencyCode',
        label: 'Account currency code',
        fieldProps: {
          options: FINTRAC_STR_CURRENCY_CODES_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
      },
    ],
    [
      {
        type: U21FormFieldTypes.SELECT,
        name: 'typeCode',
        label: 'Account type',
        fieldProps: {
          options: FINTRAC_STR_ACCOUNT_TYPE_CODE_OPTIONS,
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'typeOther',
        label: 'Other account type description',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.typeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.typeCode`
                  : '',
              conditions: (value) =>
                value !== FINTRAC_STR_ACCOUNT_TYPE_CODE.OTHER.value,
            },
          ],
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
      },
    ],
    [
      {
        type: U21FormFieldTypes.SELECT,
        name: 'virtualCurrencyTypeCode',
        label: 'Account virtual currency type',
        fieldProps: {
          options: FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE_OPTIONS,
        },
        required: false,
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          or: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) =>
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_BANK_DRAFT.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_MONEY_ORDER.value ||
                value === FINTRAC_STR_DISPOSITION_CODE.CASH_OUT.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_JEWELERY.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_PRECIOUS_METALS
                    .value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.OUTGOING_EMAIL_MONEY_TRANSFER
                    .value ||
                value === FINTRAC_STR_DISPOSITION_CODE.HOLDING_FUNDS.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.PURCHASE_OF_PRECIOUS_STONES
                    .value ||
                value === FINTRAC_STR_DISPOSITION_CODE.ISSUED_CHEQUE.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.OUTGOING_DOMESTIC_FUNDS_TRANSFER
                    .value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE
                    .OUTGOING_INTERNATIONAL_FUNDS_TRANSFER.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.DENOMINATION_EXCHANGE.value ||
                value ===
                  FINTRAC_STR_DISPOSITION_CODE.OUTGOING_MOBILE_MONEY_TRANSFER
                    .value,
            },
          ],
        },
      },
      {
        type: U21FormFieldTypes.TEXT,
        name: 'virtualCurrencyTypeOther',
        label: 'Other virtual currency type description',
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.virtualCurrencyTypeCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.virtualCurrencyTypeCode`
                  : '',
              conditions: (value) =>
                value !== FINTRAC_STR_VIRTUAL_CURRENCY_TYPE_CODE.OTHER.value,
            },
          ],
        },
        mustExistInPayload: false,
        mustHaveValueIfExist: false,
      },
    ],
    [
      {
        type: U21FormFieldTypes.DATE_PICKER,
        name: 'dateOpened',
        label: 'Date account opened',
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        fieldProps: {
          maxDate: new Date(),
        },
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
        payloadToFormValueConversion: (parentPath, flattenedPayloadValue) => {
          const dateValue = flattenedPayloadValue[`${parentPath}.dateOpened`];
          const parsed = parseFintracDate(
            typeof dateValue === 'string' ? dateValue : undefined,
          );
          return { dateOpened: parsed };
        },
        formToPayloadValueConversion: (values) => {
          if (values instanceof Date) {
            return { dateOpened: formatDate(values, FINTRAC_STR_DATE_FORMAT) };
          }
          return {};
        },
      },
      {
        type: U21FormFieldTypes.DATE_PICKER,
        name: 'dateClosed',
        label: 'Date account closed',
        required: false,
        mustExistInPayload: false,
        mustHaveValueIfExist: true,
        fieldProps: {
          maxDate: new Date(),
        },
        dependentPaths: (sectionIndex, fieldSectionIndex) =>
          getDependentPaths(
            undefined,
            fieldSectionIndex && fieldSectionIndex.length === 1
              ? [
                  `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`,
                ]
              : undefined,
            sectionIndex,
            fieldSectionIndex,
          ),
        hideIfTrue: {
          and: [
            {
              path: (sectionIndex, fieldSectionIndex) =>
                fieldSectionIndex && fieldSectionIndex.length === 1
                  ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.dispositionCode`
                  : '',
              conditions: (value) => isPhysicalFundAssetDisposition(value),
            },
          ],
        },
        payloadToFormValueConversion: (parentPath, flattenedPayloadValue) => {
          const dateValue = flattenedPayloadValue[`${parentPath}.dateClosed`];
          const parsed = parseFintracDate(
            typeof dateValue === 'string' ? dateValue : undefined,
          );
          return { dateClosed: parsed };
        },
        formToPayloadValueConversion: (values) => {
          if (values instanceof Date) {
            return { dateClosed: formatDate(values, FINTRAC_STR_DATE_FORMAT) };
          }
          return {};
        },
      },
    ],
    {
      type: 'section',
      repeatable: true,
      label: 'Account Holders Information',
      name: 'holders',
      mustExistInPayload: true,
      mustHaveValueIfExist: false,
      defaultNumOfEntries: 0,
      fields: [
        {
          type: U21FormFieldTypes.SELECT,
          name: 'typeCode',
          label: 'Account type',
          fieldProps: (_, mutators, sectionIndex, fieldSectionIndex) =>
            fieldSectionIndex && fieldSectionIndex.length === 2
              ? {
                  options: FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS,
                  onChange: () => {
                    mutators.setFieldValueUntyped(
                      `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].refId`,
                      '',
                    );
                  },
                }
              : { options: FINTRAC_STR_HOLDER_TYPE_CODE_OPTIONS },
          mustExistInPayload: true,
          mustHaveValueIfExist: true,
        },
        {
          type: U21FormFieldTypes.SELECT,
          name: 'refId',
          label: 'Subject name',
          mustExistInPayload: true,
          mustHaveValueIfExist: true,
          dependentPaths: (sectionIndex, fieldSectionIndex) =>
            getDependentPaths(
              undefined,
              fieldSectionIndex && fieldSectionIndex.length === 2
                ? [
                    `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`,
                    `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders`,
                    `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}]`,
                    'definitions', // Need to listen to definitions since getUniqueDefinitionOptions relies on definitions
                  ]
                : ['definitions'],
              sectionIndex,
              fieldSectionIndex,
            ),
          hideIfTrue: {
            and: [
              {
                path: (sectionIndex, fieldSectionIndex) =>
                  fieldSectionIndex && fieldSectionIndex.length === 2
                    ? `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`
                    : '',
                conditions: (value) => isFieldBlank(value),
              },
            ],
          },
          fieldProps: (
            flattenedValues,
            _,
            sectionIndex,
            fieldSectionIndex,
          ) => ({
            noOptionsText: ((): string => {
              if (
                !isUndefined(sectionIndex) &&
                fieldSectionIndex &&
                fieldSectionIndex.length === 2
              ) {
                const label =
                  FINTRAC_STR_DEFINITION_TYPE_CODE_MAP[
                    flattenedValues[
                      `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}].typeCode`
                    ]
                  ];

                if (label) {
                  return `No options available. Please create a new "${label}" definition in the definitions tab.`;
                }
              }

              return `No options available. Please create a new definition in the definitions tab.`;
            })(),
            options: ((): U21SelectOptionProps<string>[] =>
              !isUndefined(sectionIndex) &&
              fieldSectionIndex &&
              fieldSectionIndex.length === 2
                ? getUniqueDefinitionOptions(
                    flattenedValues,
                    `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders`,
                    `transactions[${sectionIndex}].completingActions[${fieldSectionIndex[0]}].details.account.holders[${fieldSectionIndex[1]}]`,
                  )
                : [])(),
          }),
        },
      ],
    },
  ];
